import React from 'react';
import clsx from 'clsx';
import { IProps } from './TwoColumnLayout.interface';
import { renderBlock } from '@/app/index';
import './TwoColumnLayout.styles.css';
import { defaultProps } from '@/blocks/SecondaryNavigation/SecondaryNavigation.props';

export const TwoColumnLayout: React.FC<IProps> = ({
    left = [
        { name: 'SecondaryNavigation', props: defaultProps },
    ],
    right,
    layout = 'right',
    className,
}) => {
    const layoutClasses = {
        left: 'twoColumnLayout__layout--left',
        right: 'twoColumnLayout__layout--right',
        half: 'twoColumnLayout__layout--half',
    };

    return (
        <div className={clsx('twoColumnLayout', className, 'twoColumnLayout__layout', layoutClasses[layout])}>
            <div className="twoColumnLayout__column--left">
                {left?.map((block, index) => renderBlock(block, index))}
            </div>
            <div className="twoColumnLayout__column--right">
                {right?.map((block, index) => renderBlock(block, index))}
            </div>
        </div>
    );
};
